import { Select } from "@mantine/core";
import { Dispatch, useCallback } from "react";
import { CatalogueAction } from "../../../hooks/admin/useSystemEmailsPage";
import { SystemEmailMode } from "../../../services/admin/systemEmails.service";

interface Props {
  value: SystemEmailMode | null;
  dispatch: Dispatch<CatalogueAction>;
}
const OPTIONS = [
  { value: "on", label: "On" },
  { value: "review", label: "Review" },
  { value: "off", label: "Off" },
];

export function SystemEmailModeFilter({ value, dispatch }: Props) {
  const change = useCallback(
    (next: string | null) =>
      dispatch({ type: "mode", value: next as SystemEmailMode | null }),
    [dispatch]
  );
  return (
    <Select
      clearable
      data={OPTIONS}
      label="Mode"
      onChange={change}
      placeholder="All modes"
      value={value}
    />
  );
}
